module.exports = __webpack_public_path__ + "static/laptop_web_development-079750ada18046be2755ca07c975d71f.png";